export default __webpack_public_path__ + "static/media/Vector.a4a9aa06.svg";